export default "__VITE_ASSET__CYgajTMY__"